import { ReactNode } from 'react';
import { Controlled as Zoom } from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';

import useBoolean from 'hooks/useBoolean';

type Props = Omit<Parameters<typeof Zoom>[0], 'isZoomed' | 'onZoomChange' | 'children'> &
  (
    | {
        isZoomed?: boolean;
        children: ReactNode;
        onZoomChange?: () => void;
      }
    | {
        isZoomed?: undefined;
        children: (props: { isZoomed: boolean; onZoomChange: () => void }) => JSX.Element;
        onZoomChange?: undefined;
      }
  );

const ImageZoom = ({
  isZoomed: controlledIsZoomed,
  onZoomChange: controlledOnZoomChange,
  children,
  ...restProps
}: Props): JSX.Element => {
  const [isZoomed, { toggle: toggleZoom }] = useBoolean(false);
  const finalIsZoomed = typeof controlledIsZoomed !== 'undefined' ? controlledIsZoomed : isZoomed;
  const finalOnZoomChange = typeof controlledOnZoomChange !== 'undefined' ? controlledOnZoomChange : toggleZoom;

  return (
    <Zoom isZoomed={finalIsZoomed} onZoomChange={finalOnZoomChange} {...restProps}>
      {typeof children === 'function'
        ? children({
            isZoomed: finalIsZoomed,
            onZoomChange: finalOnZoomChange,
          })
        : children}
    </Zoom>
  );
};

export default ImageZoom;
